import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import logo from '../../assets/images/MC3.png';

const Navbar = () => {
    const theme = useTheme();
    const [anchorElHome, setAnchorElHome] = useState(null);
    const [anchorElPages, setAnchorElPages] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [openSubMenu, setOpenSubMenu] = useState({});

    const handleOpen = (setAnchor) => (event) => {
        setAnchor(event.currentTarget);
    };

    const handleClose = (setAnchor) => () => {
        setAnchor(null);
    };

    const toggleDrawer = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleSubMenuToggle = (key) => {
        setOpenSubMenu((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const drawerContent = (
        <Box
            sx={{
                width: 250,
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.secondary.main,
                height: '100%',
            }}
            role="presentation"
        >
            <List>
                <ListItem disablePadding>
                    <ListItemButton component={Link} to="/">
                        <ListItemText primary="Home" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton component={Link} to="${process.env.REACT_APP_BASE}about-us">
                        <ListItemText primary="About Us" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton component={Link} to="${process.env.REACT_APP_BASE}our-services">
                        <ListItemText primary="Services" />
                    </ListItemButton>
                </ListItem>
                {/* <ListItem disablePadding>
                    <ListItemButton onClick={() => handleSubMenuToggle('features')}>
                        <ListItemText primary="Features" />
                        {openSubMenu.features ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                </ListItem> */}
                {/* <Collapse in={openSubMenu.features} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/features/home1" sx={{ pl: 4 }}>
                            <ListItemText primary="Home1" />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/features/home2" sx={{ pl: 4 }}>
                            <ListItemText primary="Home2" />
                        </ListItemButton>
                    </List>
                </Collapse> */}

                <ListItem disablePadding>
                    <ListItemButton component={Link} to="/expertize">
                        <ListItemText primary="Expertise" />
                    </ListItemButton>
                </ListItem>

                {/* <ListItem disablePadding>
                    <ListItemButton component={Link} to="/team">
                        <ListItemText primary="Team" />
                    </ListItemButton>
                </ListItem> */}

                {/* <ListItem disablePadding>
                    <ListItemButton onClick={() => handleSubMenuToggle('pages')}>
                        <ListItemText primary="Pages" />
                        {openSubMenu.pages ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                </ListItem> */}
                {/* <Collapse in={openSubMenu.pages} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/pages/page1" sx={{ pl: 4 }}>
                            <ListItemText primary="Page1" />
                        </ListItemButton>
                        <ListItemButton component={Link} to="/pages/page2" sx={{ pl: 4 }}>
                            <ListItemText primary="Page2" />
                        </ListItemButton>
                    </List>
                </Collapse> */}

                <ListItem disablePadding>
                    <ListItemButton component={Link} to="/contact-us">
                        <ListItemText primary="Contact Us" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <AppBar
            position="sticky"
            sx={{
                backgroundColor: '#ffff',
                boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
                zIndex: 1000,
                top: 0,
                transition: 'all 0.3s ease',
            }}
        >
            <Container>
                <Toolbar>
                    <Box
                        sx={{
                            flexGrow: 1,
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            marginTop: "10px",
                            marginBottom: "10px",
                            display: "flex",

                            alignItems: "center",
                        }}
                    >
                        <Link to="/" style={{ textDecoration: "none" }}>
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ height: 50, margin: "auto", cursor: "pointer" }}
                            />
                        </Link>
                    </Box>
                    {/* Desktop Navigation */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
                        <Button component={Link} to="/" sx={{ fontWeight: theme.typography.fontWeightBold, color: theme.palette.secondary.main }}>
                            Home
                        </Button>
                        <Button component={Link} to="/about-us" sx={{ fontWeight: theme.typography.fontWeightBold, color: theme.palette.secondary.main }}>
                            About Us
                        </Button>
                        <Button component={Link} to="/our-services" sx={{ fontWeight: theme.typography.fontWeightBold, color: theme.palette.secondary.main }}>
                           Services
                        </Button>
                       

                        <Button component={Link} to="/expertize" sx={{ fontWeight: theme.typography.fontWeightBold, color: theme.palette.secondary.main }}>
                            Expertize
                        </Button>
                        
                        <Button
                            component={Link}
                            to="/contact-us"
                            sx={{
                                color: theme.palette.primary.main,
                                fontWeight: theme.typography.fontWeightBold,
                                borderRadius: '4px',
                                padding: '8px 16px',
                                backgroundColor: theme.palette.tertiary.main,
                                transition: 'background-color 0.3s ease, transform 0.3s ease',
                                '&:hover': {
                                    backgroundColor: theme.palette.secondary.main,
                                    transform: 'scale(1.05)',
                                },
                            }}
                        >
                            Contact Us
                        </Button>
                    </Box>

                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        sx={{ color: theme.palette.secondary.main, display: { md: 'none' } }}
                        onClick={toggleDrawer}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer}>
                        {drawerContent}
                    </Drawer>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;
